export class NguoiDungResponse {
    "id": number;
    "tenDangNhap": string;
    "hoTen": string;
    "tenDonVi": string;
    "idDonVi": number;
    "dienThoai": string;
    "email": string;
    "ngaySinh": Date | null;
    "canCuocChungMinh": string;
    "noiCap": string;
    "ngayCap": Date | null;
    "ngayKhoiTao": Date;
    "kichHoat": boolean;
    "isAdmin": boolean;
    "tenChucVu": string;
    "avatar": string;
}

export class TaiKhoanResponse {
    "id": number;
    "tenDangNhap": string;
    "kichHoat": boolean;
    "isAdmin": boolean;
}

export class NguoiDungPagingResponse {
    "data": Array<NguoiDungResponse>;
    "recordsTotal": number;
    "maxPage": number;
    "pageCurrent": number;
    "pageListShow": Array<number>;
}

export class DoiMatKhauRequest {
    "matKhauCu": string;
    "matKhauMoi": string;
    "xacNhanMatKhau": string;
}